export const INITIAL_AUTH_STATE = {
  hasError: false,
  isAuthenticated: false,
  pageError: null,
};

export const AUTH_ACTIONS = {
  SET_ERROR: "SET_ERROR",
  SET_AUTHENTICATED: "SET_AUTHENTICATED",
};

export const authReducer = (state, action) => {
  switch (action.type) {
    case AUTH_ACTIONS.SET_ERROR:
      return { hasError: true, isAuthenticated: false, pageError: action.payload };
    case AUTH_ACTIONS.SET_AUTHENTICATED:
      return { hasError: false, isAuthenticated: true, pageError: null };
    default:
      return state;
  }
};

export const buildAuthError = (StatusCode, ErrorName, ErrorDescription, translation) => ({
  StatusCode,
  ErrorName,
  ErrorDescription,
  url: "/",
  buttonText: translation?.backToHome,
});
